<script setup>
import { ref, computed } from 'vue';
import VArrow from '@/components/images/VArrow.vue';

const props = defineProps({
  questions: {
    type: Array, // [{ q: string; a: string | string[] }]
    default: () => [],
  },
  version: {
    type: String, // 1 | 2
    default: '1',
  },
});

const accordionVersion = computed(() => `accordion-v${props.version}`);

const openIndex = ref(0);

const toggleAccordion = (index) => {
  openIndex.value = openIndex.value === index ? null : index;
};
</script>

<template>
  <div :class="accordionVersion" class="mx-auto">
    <div
      v-fade-up
      v-for="(item, i) in questions"
      :key="i"
      class="border-b relative accordion-item-wrapper"
    >
      <button
        @click="toggleAccordion(i)"
        class="w-full flex justify-between items-start font-bold hover:cursor-pointer accordion-question"
      >
        <div class="w-full">
          {{ item.q }}
        </div>
        <VArrow
          :class="[
            openIndex === i ? 'rotate-0' : 'rotate-180',
            version,
            'transition-all duration-300 w-3.5 h-auto accordion-question-arrow ml-6 mt-2',
          ]"
        />
      </button>
      <!-- content -->
      <div
        :class="[
          'grid transition-all duration-300 ease-in-out',
          openIndex === i
            ? 'grid-rows-[1fr] opacity-100'
            : 'grid-rows-[0fr] opacity-0',
        ]"
      >
        <div
          class="overflow-hidden accordion-answer transition-all duration-300"
          :class="{ 'accordion-answer--active': openIndex === i }"
        >
          <span v-if="typeof item.a === 'string'">{{ item.a }}</span>
          <template v-else>
            <div
              v-for="(answer, idx) in item.a"
              :key="idx"
              class="not-last:mb-4"
            >
              {{ answer }}
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
